const translations = {
	nl: {
		// Header
		siteTitle: 'Visualiseer mijn pensioen',
		siteSubtitle: 'Bereken wat er gebeurt als je elke maand geld opzij legt — en zie de kracht van samengestelde rente.',

		// Navigation tabs
		tabPlanner: '📈 Pensioenplanner',
		tabEmigrate: '✈️ Emigreren',
		tabBlog: '📝 Blog',
		tabSave: '💰 Besparen',

		// Home page body text
		homeIntro: 'Veel mensen',
		homeDreamLink: 'dromen van een vroeg pensioen',
		homeBody1: '. Weinig mensen doen er echter daadwerkelijk wat aan om dit te bereiken. Met behulp van deze tool kun je inzicht krijgen wat het voor jou betekent als je elke maand geld extra opzij legt.',
		homeBody2KDM: 'KDM',
		homeBody2: 'Het leven draait om',
		homeBody2Colon: ':',
		homeBody2Desc: 'karakter, discipline en motivatie',
		homeBody2End: '. Wanneer jij deze drie elementen beheerst en je',
		homeBody2Monthly: 'elke maand, jaar in jaar uit',
		homeBody2Final: 'aandelen koopt, dan is jouw pensioen dichter bij dan je ooit had durven dromen!',
		homeSponsor: 'Deze site is mede mogelijk gemaakt door trotse sponsor DdS',

		// 404
		notFound: 'Pagina niet gevonden',
		backToPlanner: 'Terug naar de pensioenplanner →',

		// Graph / Calculator
		labelDuration: 'Tijdsduur',
		labelYears: 'jaar',
		labelInitialDeposit: 'Initiële storting',
		labelMonthlyDeposit: 'Maandelijkse storting',
		labelReturn: 'Rendement',
		labelTotalWealth: 'Totaal vermogen',
		labelTotalInvested: 'Totaal ingelegd',
		labelProfit: 'Rendement',
		labelMonthlyIncome: 'Maandelijks inkomen (4%)',
		labelAfterBox3: 'Na Box 3',
		labelPerMonth: '/mnd',
		chartTotalWealth: 'Totaal vermogen',
		chartInvested: 'Ingelegd',
		chartAfterBox3: 'Na Box 3 (2028)',
		box3Label: 'Box 3 belasting (2028) — 36% op rendement',
		box3Warning: '⚠️ Let op: de nieuwe Box 3-wetgeving is nog niet definitief vastgesteld. De berekening is gebaseerd op het huidige voorstel.',
		box3CTA: 'Geen zin in die belasting? Bekijk emigratieopties ✈️',
		tooltipCopied: 'Link gekopieerd!',
		tooltipShare: 'Deel jouw berekening',
		footerNote1: '* Inflatie is niet meegenomen. Dit kun je naar eigen inzicht van het ingeschatte rendement aftrekken. Deze tool houdt ook geen rekening met AOW of ander opgebouwd pensioen.',
		footerNote2: '** Box 3 (2028): 36% belasting op werkelijk rendement boven het heffingvrij rendement van €1.800 per jaar. Vóór 2028 geldt het huidige stelsel.',

		// Emigrate page
		emigrateTitle: 'Geen zin in Box 3? ✈️',
		emigrateSubtitle: 'Als 36% belasting op je rendement je toch een beetje dwars zit, zijn hier de populairste bestemmingen voor de fiscaal geëmigreerde Nederlander. Puur informatief natuurlijk. 🙃',
		emigrateChip: '🇳🇱 Gemiddelde Box 3 druk: 36% op rendement',
		emigratePros: '✓ Voordelen',
		emigrateCons: '✗ Nadelen',
		emigrateFullGuide: 'Volledige gids',
		emigrateDisclaimer: '⚖️ Disclaimer: Dit is geen belastingadvies. Emigreren heeft grote persoonlijke, juridische en fiscale gevolgen. Raadpleeg een gespecialiseerde belastingadviseur voordat je je paspoort pakt. Ook na emigratie kan Nederland je nog jaren blijven belasten (exitbelasting, fictieve woonplaats).',

		// Country detail page
		countryNotFound: 'Land niet gevonden',
		backToOverview: 'Terug naar overzicht',
		allDestinations: 'Alle bestemmingen',
		pros: '✓ Voordelen',
		cons: '✗ Nadelen',
		calculatePension: 'Bereken jouw pensioen',
		countryDisclaimer: '⚖️ Disclaimer: Dit is geen belastingadvies. Emigreren heeft grote persoonlijke, juridische en fiscale gevolgen. Raadpleeg een gespecialiseerde belastingadviseur voordat je je paspoort pakt. Ook na emigratie kan Nederland je nog jaren blijven belasten (exitbelasting, fictieve woonplaats). De informatie op deze pagina is met zorg samengesteld maar kan verouderd of onvolledig zijn.',

		// Blog index
		blogTitle: 'Blog',
		blogSubtitle: 'Reisgidsen, financieel advies en pensioenoriëntatie — voor Nederlanders die meer willen dan de standaard vakantie.',
		blogCategories: ['Alles', 'Financieel & FIRE', 'Spanje', 'Portugal', 'Thailand', 'Dubai & VAE', 'Cyprus', 'Zwitserland', 'Singapore & Monaco'],
		blogReadTime: 'min leestijd',
		blogReadMore: 'Lees meer',
		blogMetaTitle: 'Blog: FIRE, pensioen, reizen en emigreren | VisualiseermijnPensioen.nl',
		blogMetaDesc: 'Artikelen over FIRE, vroegpensioen, Box 3, ETFs en reizen naar pensioenbestemmingen in Spanje, Portugal, Thailand en meer.',

		// Blog post page
		articleNotFound: 'Artikel niet gevonden',
		backToBlog: 'Terug naar blog',
		allArticles: 'Alle artikelen',
		readTime: 'min leestijd',
		blogCTATitle: 'Bereken jouw eigen pensioenscenario',
		blogCTABody: 'Gebruik de pensioenplanner om te zien hoeveel je vermogen groeit met samengestelde rente — inclusief de impact van Box 3.',
		blogCTAButton: 'Open de calculator',
		dateLocale: 'nl-NL',
	},
	en: {
		// Header
		siteTitle: 'Visualize my pension',
		siteSubtitle: 'Calculate what happens when you set aside money every month — and see the power of compound interest.',

		// Navigation tabs
		tabPlanner: '📈 Pension Planner',
		tabEmigrate: '✈️ Emigrate',
		tabBlog: '📝 Blog',
		tabSave: '💰 Save Money',

		// Home page body text
		homeIntro: 'Many people',
		homeDreamLink: 'dream of early retirement',
		homeBody1: ', but few actually take steps to make it happen. This tool lets you see what it means for you if you set aside a little extra every month.',
		homeBody2KDM: 'CDM',
		homeBody2: 'Life is about',
		homeBody2Colon: ':',
		homeBody2Desc: 'character, discipline, and motivation',
		homeBody2End: '. Master these three elements and keep buying shares',
		homeBody2Monthly: 'every month, year after year',
		homeBody2Final: ', and retirement will be closer than you ever dared to dream!',
		homeSponsor: 'This site is made possible by proud sponsor DdS',

		// 404
		notFound: 'Page not found',
		backToPlanner: 'Back to the pension planner →',

		// Graph / Calculator
		labelDuration: 'Duration',
		labelYears: 'years',
		labelInitialDeposit: 'Initial deposit',
		labelMonthlyDeposit: 'Monthly deposit',
		labelReturn: 'Return',
		labelTotalWealth: 'Total wealth',
		labelTotalInvested: 'Total invested',
		labelProfit: 'Return',
		labelMonthlyIncome: 'Monthly income (4%)',
		labelAfterBox3: 'After Box 3',
		labelPerMonth: '/mo',
		chartTotalWealth: 'Total wealth',
		chartInvested: 'Invested',
		chartAfterBox3: 'After Box 3 (2028)',
		box3Label: 'Box 3 tax (2028) — 36% on returns',
		box3Warning: '⚠️ Note: the new Box 3 legislation has not yet been finalized. The calculation is based on the current proposal.',
		box3CTA: "Don't want that tax? Check emigration options ✈️",
		tooltipCopied: 'Link copied!',
		tooltipShare: 'Share your calculation',
		footerNote1: '* Inflation is not included. You can subtract it from the estimated return at your own discretion. This tool also does not account for state pension (AOW) or other accrued pension benefits.',
		footerNote2: '** Box 3 (2028): 36% tax on actual returns above the tax-free threshold of €1,800 per year. Before 2028 the current system applies.',

		// Emigrate page
		emigrateTitle: 'Fed up with Box 3? ✈️',
		emigrateSubtitle: "If 36% tax on your returns is getting under your skin, here are the most popular destinations for Dutch fiscal emigrants. Purely informational, of course. 🙃",
		emigrateChip: '🇳🇱 Average Box 3 burden: 36% on returns',
		emigratePros: '✓ Advantages',
		emigrateCons: '✗ Disadvantages',
		emigrateFullGuide: 'Full guide',
		emigrateDisclaimer: '⚖️ Disclaimer: This is not tax advice. Emigrating has major personal, legal, and fiscal consequences. Consult a specialist tax advisor before packing your passport. Even after emigration, the Netherlands may continue to tax you for years (exit tax, fictitious residency).',

		// Country detail page
		countryNotFound: 'Country not found',
		backToOverview: 'Back to overview',
		allDestinations: 'All destinations',
		pros: '✓ Advantages',
		cons: '✗ Disadvantages',
		calculatePension: 'Calculate your pension',
		countryDisclaimer: '⚖️ Disclaimer: This is not tax advice. Emigrating has major personal, legal, and fiscal consequences. Consult a specialist tax advisor before packing your passport. Even after emigration, the Netherlands may continue to tax you for years (exit tax, fictitious residency). The information on this page has been compiled with care but may be outdated or incomplete.',

		// Blog index
		blogTitle: 'Blog',
		blogSubtitle: 'Travel guides, financial advice, and retirement orientation — for Dutch people who want more than the standard holiday.',
		blogCategories: ['All', 'Financial & FIRE', 'Spain', 'Portugal', 'Thailand', 'Dubai & UAE', 'Cyprus', 'Switzerland', 'Singapore & Monaco'],
		blogReadTime: 'min read',
		blogReadMore: 'Read more',
		blogMetaTitle: 'Blog: FIRE, pension, travel and emigration | VisualiseermijnPensioen.nl',
		blogMetaDesc: 'Articles about FIRE, early retirement, Box 3, ETFs and travel to retirement destinations in Spain, Portugal, Thailand and more.',

		// Blog post page
		articleNotFound: 'Article not found',
		backToBlog: 'Back to blog',
		allArticles: 'All articles',
		readTime: 'min read',
		blogCTATitle: 'Calculate your own retirement scenario',
		blogCTABody: 'Use the pension planner to see how much your wealth grows with compound interest — including the impact of Box 3.',
		blogCTAButton: 'Open the calculator',
		dateLocale: 'en-US',
	},
};

export const useT = (language) => (key) => translations[language]?.[key] ?? translations.nl[key] ?? key;

export default translations;
